import { useDispatch } from '@redux';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReceivedModal from './Modal/ReceivedModal';
import crudActions from '@redux/crudActions';

const ConfirmReceivedButton = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleReceivedModal = (value) => {
    dispatch(
      crudActions.modal.toogleModal({
        ['received']: {
          isOpen: value,
        },
      } as any),
    );
  };

  return (
    <>
      <Button onClick={handleReceivedModal} type="primary">
        {t('transferOrders.confirmReceived')}
      </Button>
      <ReceivedModal data={data} onCancel={() => handleReceivedModal(false)} />
    </>
  );
};

export default ConfirmReceivedButton;
